import React, { useEffect, useRef, useState } from 'react';
import './FlerpieChatBot.css';

const NeutralSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="n-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="0.9"/>
        <stop offset="40%" stopColor="#FFCC33" stopOpacity="0.4"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <radialGradient id="n-abdomen" cx="45%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#FFE066"/>
        <stop offset="60%" stopColor="#FFCC33"/>
        <stop offset="100%" stopColor="#E6A800"/>
      </radialGradient>
      <linearGradient id="n-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <linearGradient id="n-wing" x1="0" y1="0" x2="0.5" y2="1">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="0.20"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0.06"/>
      </linearGradient>
      <radialGradient id="n-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="n-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
      </filter>
      <clipPath id="n-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="26" ry="18" fill="url(#n-glow)" filter="url(#n-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#n-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.35" clipPath="url(#n-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    {/* Eyes — anime-ish shape, simple fills */}
    <path d="M43,26 Q43,19 50,18 Q57,19 57,26 Q57,32 50,32 Q43,32 43,26 Z" fill="url(#n-eye-shine)"/>
    <path d="M63,26 Q63,19 70,18 Q77,19 77,26 Q77,32 70,32 Q63,32 63,26 Z" fill="url(#n-eye-shine)"/>
    {/* Pupils */}
    <ellipse cx="50" cy="27" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
    <ellipse cx="70" cy="27" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
    {/* Highlights */}
    <circle cx="48" cy="23.5" r="2" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="68" cy="23.5" r="2" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="52.5" cy="29" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>
    <circle cx="72.5" cy="29" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>

    {/* Gentle smile */}
    <path d="M53,36 Q60,41 67,36" fill="none" stroke="#6B6568" strokeWidth="1.5" strokeLinecap="round"/>

    <path d="M50 12 Q46 4 40 2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="39" cy="1.5" r="2.5" fill="#FFCC33"/>
    <path d="M70 12 Q74 4 80 2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="81" cy="1.5" r="2.5" fill="#FFCC33"/>

    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const LaughingSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="la-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="0.95"/>
        <stop offset="40%" stopColor="#FFCC33" stopOpacity="0.5"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="la-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <filter id="la-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
      </filter>
      <clipPath id="la-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="26" ry="18" fill="url(#la-glow)" filter="url(#la-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#la-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.35" clipPath="url(#la-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    {/* Laughing eyes — crescent squints, teared up */}
    <path d="M44,24 Q50,20 56,24" fill="none" stroke="#E0E0E0" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M64,24 Q70,20 76,24" fill="none" stroke="#E0E0E0" strokeWidth="2.5" strokeLinecap="round"/>
    {/* Tiny laugh tears */}
    <circle cx="57" cy="24" r="1" fill="#FFFFFF" opacity="0.5"/>
    <circle cx="77" cy="24" r="1" fill="#FFFFFF" opacity="0.5"/>

    {/* Wide open laugh mouth :D — flat top, curved bottom */}
    <path className="laugh-mouth" d="M53,35 L67,35 Q67,44 60,44 Q53,44 53,35 Z" fill="#9A7080"/>

    {/* Antennae — bouncing with laughter, mirrored */}
    <g className="laugh-antenna-l">
      <path d="M50 12 Q46 4 40 2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="39" cy="1.5" r="2.5" fill="#FFCC33"/>
    </g>
    <g className="laugh-antenna-r">
      <path d="M70 12 Q74 4 80 2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="81" cy="1.5" r="2.5" fill="#FFCC33"/>
    </g>

    {/* Legs — left and right flail during laughter */}
    <g className="laugh-legs-l">
      <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
      <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
      <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    </g>
    <g className="laugh-legs-r">
      <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
      <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
      <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    </g>
  </svg>
);

const SteadySVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="st-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="0.9"/>
        <stop offset="40%" stopColor="#FFCC33" stopOpacity="0.4"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="st-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <radialGradient id="st-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="st-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
      </filter>
      <clipPath id="st-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="26" ry="18" fill="url(#st-glow)" filter="url(#st-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#st-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.35" clipPath="url(#st-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    {/* Closed happy eyes — content squint arcs */}
    <path d="M44,26 Q50,22 56,26" fill="none" stroke="#E0E0E0" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M64,26 Q70,22 76,26" fill="none" stroke="#E0E0E0" strokeWidth="2.5" strokeLinecap="round"/>

    {/* Wider smile — "here you go!" */}
    <path d="M50,36 Q60,44 70,36" fill="none" stroke="#6B6568" strokeWidth="1.5" strokeLinecap="round"/>

    {/* Antennae */}
    <path d="M50 12 Q46 4 40 2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="39" cy="1.5" r="2.5" fill="#FFCC33"/>
    <path d="M70 12 Q74 4 80 2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="81" cy="1.5" r="2.5" fill="#FFCC33"/>

    {/* Legs */}
    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const ThinkingSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="t-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="0.6"/>
        <stop offset="40%" stopColor="#FFCC33" stopOpacity="0.2"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="t-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <radialGradient id="t-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="t-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
      </filter>
      <clipPath id="t-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="26" ry="18" fill="url(#t-glow)" filter="url(#t-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#t-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.25" clipPath="url(#t-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    <path d="M43,26 Q43,19 50,18 Q57,19 57,26 Q57,32 50,32 Q43,32 43,26 Z" fill="url(#t-eye-shine)"/>
    <path d="M63,26 Q63,19 70,18 Q77,19 77,26 Q77,32 70,32 Q63,32 63,26 Z" fill="url(#t-eye-shine)"/>
    {/* Pupils — drift side-to-side while thinking */}
    <g className="thinking-eye-drift">
      <ellipse cx="53" cy="24" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
      <ellipse cx="73" cy="24" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
      <circle cx="51" cy="21.5" r="2" fill="#FFFFFF" className="eye-inner"/>
      <circle cx="71" cy="21.5" r="2" fill="#FFFFFF" className="eye-inner"/>
      <circle cx="55" cy="27" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>
      <circle cx="75" cy="27" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>
    </g>

    <path d="M50 12 Q46 4 40 2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="39" cy="1.5" r="2.5" fill="#FFCC33"/>
    <path d="M70 12 Q74 4 80 2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="81" cy="1.5" r="2.5" fill="#FFCC33"/>

    <path d="M44,18 Q50,16 56,18" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <path d="M44,18 Q50,16 56,18" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M64,15 Q70,12 76,15" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <path d="M64,15 Q70,12 76,15" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>

    {/* Thinking — small flat line */}
    <path d="M54,37 L62,37" fill="none" stroke="#6B6568" strokeWidth="1.5" strokeLinecap="round"/>

    <g className="thought-bubbles">
      <circle className="thought-sm" cx="84" cy="20" r="2" fill="#FFCC33" opacity="0"/>
      <circle className="thought-md" cx="90" cy="14" r="3" fill="#FFCC33" opacity="0"/>
      {/* Cloud thought bubble — single clipped fill for uniform opacity */}
      <g className="thought-lg" opacity="0">
        <defs>
          <clipPath id="t-cloud-clip">
            <circle cx="94" cy="4" r="4.5"/>
            <circle cx="99" cy="1" r="5.5"/>
            <circle cx="105" cy="3" r="5"/>
            <circle cx="97" cy="6" r="4"/>
            <circle cx="103" cy="7" r="4"/>
          </clipPath>
        </defs>
        {/* Soft glow behind cloud */}
        <g filter="url(#t-softGlow)" opacity="0.15">
          <circle cx="99" cy="3" r="9" fill="#FFCC33"/>
        </g>
        {/* Cloud fill — single rect clipped to cloud shape = no overlap artifacts */}
        <rect x="87" y="-6" width="24" height="18" fill="#FFCC33" opacity="0.3" clipPath="url(#t-cloud-clip)"/>
        {/* Ellipsis dots — sequential pulse inside cloud */}
        <g className="thought-ellipsis">
          <circle className="ellipsis-1" cx="95" cy="4" r="1.2" fill="#FFCC33" opacity="0"/>
          <circle className="ellipsis-2" cx="99.5" cy="3.5" r="1.2" fill="#FFCC33" opacity="0"/>
          <circle className="ellipsis-3" cx="104" cy="4" r="1.2" fill="#FFCC33" opacity="0"/>
        </g>
      </g>
    </g>

    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const ExcitedSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="e-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="1"/>
        <stop offset="40%" stopColor="#FFCC33" stopOpacity="0.6"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="e-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <radialGradient id="e-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="e-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="5"/>
      </filter>
      <clipPath id="e-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="30" ry="22" fill="url(#e-glow)" filter="url(#e-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="38" cy="54" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.16" stroke="#FFCC33" strokeOpacity="0.3" strokeWidth="0.8" transform="rotate(20 38 54)"/>
      <ellipse cx="82" cy="54" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.16" stroke="#FFCC33" strokeOpacity="0.3" strokeWidth="0.8" transform="rotate(-20 82 54)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#e-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.45" clipPath="url(#e-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    {/* Eyes — bigger for excitement */}
    <path d="M41,26 Q41,18 50,17 Q59,18 59,26 Q59,34 50,34 Q41,34 41,26 Z" fill="url(#e-eye-shine)"/>
    <path d="M61,26 Q61,18 70,17 Q79,18 79,26 Q79,34 70,34 Q61,34 61,26 Z" fill="url(#e-eye-shine)"/>
    <ellipse cx="50" cy="27" rx="4.5" ry="5" fill="#1A1A1A" className="eye-inner"/>
    <ellipse cx="70" cy="27" rx="4.5" ry="5" fill="#1A1A1A" className="eye-inner"/>
    <circle cx="48" cy="23" r="2.2" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="68" cy="23" r="2.2" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="53" cy="29.5" r="1.2" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>
    <circle cx="73" cy="29.5" r="1.2" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>

    <path d="M50 12 Q48 2 42 -4" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="41" cy="-5" r="2.5" fill="#FFCC33"/>
    <path d="M70 12 Q72 2 78 -4" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="79" cy="-5" r="2.5" fill="#FFCC33"/>

    <path d="M43,16 Q50,12 57,16" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <path d="M43,16 Q50,12 57,16" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M63,16 Q70,12 77,16" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <path d="M63,16 Q70,12 77,16" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>

    {/* Anime blush — // lines, tucked inside face */}
    <line x1="39" y1="31" x2="40.5" y2="34" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="41" y1="31" x2="42.5" y2="34" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="43" y1="31" x2="44.5" y2="34" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="75.5" y1="31" x2="77" y2="34" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="77.5" y1="31" x2="79" y2="34" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="79.5" y1="31" x2="81" y2="34" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>

    {/* Excited — big happy smile */}
    <path d="M50,35 Q60,43 70,35" fill="none" stroke="#6B6568" strokeWidth="2" strokeLinecap="round"/>

    {/* Sparkle stars */}
    <path d="M88,16 L90,12 L92,16 L88,14 L92,14 Z" fill="#FFCC33" opacity="0.6"/>
    <path d="M28,16 L30,12 L32,16 L28,14 L32,14 Z" fill="#FFCC33" opacity="0.6"/>

    {/* Speed lines — radiating outward */}
    <g className="speed-lines">
      <line x1="18" y1="20" x2="8" y2="16" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
      <line x1="16" y1="40" x2="6" y2="40" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.4"/>
      <line x1="20" y1="58" x2="10" y2="62" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.3"/>
      <line x1="102" y1="20" x2="112" y2="16" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
      <line x1="104" y1="40" x2="114" y2="40" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.4"/>
      <line x1="100" y1="58" x2="110" y2="62" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.3"/>
    </g>

    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const ConcernedSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="c-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#F0A500" stopOpacity="0.7"/>
        <stop offset="40%" stopColor="#F0A500" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#F0A500" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="c-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#8A6A18"/>
        <stop offset="90%" stopColor="#C09020"/>
        <stop offset="100%" stopColor="#E6A800"/>
      </linearGradient>
      <radialGradient id="c-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="c-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
      </filter>
      <clipPath id="c-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="26" ry="18" fill="url(#c-glow)" filter="url(#c-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#c-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#E6A800" opacity="0.3" clipPath="url(#c-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    <path d="M43,26 Q43,19 50,18 Q57,19 57,26 Q57,32 50,32 Q43,32 43,26 Z" fill="url(#c-eye-shine)"/>
    <path d="M63,26 Q63,19 70,18 Q77,19 77,26 Q77,32 70,32 Q63,32 63,26 Z" fill="url(#c-eye-shine)"/>
    {/* Pupils — slightly lower for worried look */}
    <ellipse cx="50" cy="28" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
    <ellipse cx="70" cy="28" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
    <circle cx="48" cy="24" r="2" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="68" cy="24" r="2" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="52.5" cy="30" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>
    <circle cx="72.5" cy="30" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>

    <path d="M50 12 Q44 6 38 6" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="37" cy="5.5" r="2.5" fill="#FFCC33"/>
    <path d="M70 12 Q76 6 82 6" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="83" cy="5.5" r="2.5" fill="#FFCC33"/>

    <path d="M43,17 Q48,20 56,17" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <path d="M43,17 Q48,20 56,17" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M64,17 Q72,20 77,17" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <path d="M64,17 Q72,20 77,17" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>

    {/* Concerned — small frown */}
    <path d="M54,37 Q60,34 66,37" fill="none" stroke="#6B6568" strokeWidth="1.5" strokeLinecap="round"/>

    {/* Anime sweat drop — slides down into position */}
    <g className="sweat-drop">
      <path d="M84,8 L88,22 Q88,28 84,28 Q80,28 80,22 Z" fill="#88CCEE" opacity="0.6"/>
      <ellipse cx="84" cy="23" rx="2" ry="1.5" fill="#BBDDEE" opacity="0.4"/>
    </g>

    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const ConfusedSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="cf-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="0.7"/>
        <stop offset="40%" stopColor="#FFCC33" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="cf-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <radialGradient id="cf-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="cf-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
      </filter>
      <clipPath id="cf-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="26" ry="18" fill="url(#cf-glow)" filter="url(#cf-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#cf-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.35" clipPath="url(#cf-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    {/* Single rotated group for confused head — keeps blink transforms clean */}
    <g transform="rotate(-8 60 28)">
      <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

      {/* Eyes — mismatched sizes for confusion */}
      <path d="M41,25 Q41,19 48,18 Q55,19 55,25 Q55,31 48,31 Q41,31 41,25 Z" fill="url(#cf-eye-shine)"/>
      <path d="M61,25 Q61,18 69,17 Q77,18 77,25 Q77,32 69,32 Q61,32 61,25 Z" fill="url(#cf-eye-shine)"/>
      <ellipse cx="48" cy="26" rx="3.5" ry="4" fill="#1A1A1A" className="eye-inner"/>
      <ellipse cx="69" cy="26" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
      <circle cx="46" cy="23" r="1.8" fill="#FFFFFF" className="eye-inner"/>
      <circle cx="67" cy="22.5" r="2" fill="#FFFFFF" className="eye-inner"/>
      <circle cx="50.5" cy="28.5" r="0.8" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>
      <circle cx="71.5" cy="29" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>

      <path d="M48 11 Q42 4 38 6" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="37" cy="5.5" r="2.5" fill="#FFCC33"/>
      <path d="M70 11 Q78 0 74 6 Q72 10 78 4" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="78.5" cy="3" r="2.5" fill="#FFCC33"/>

      <path d="M42,17 Q48,19 54,16" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
      <path d="M42,17 Q48,19 54,16" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>
      <path d="M63,13 Q69,10 75,14" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
      <path d="M63,13 Q69,10 75,14" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>

      {/* Confused — lopsided frown */}
      <path d="M53,37 Q58,34 65,36" fill="none" stroke="#6B6568" strokeWidth="1.5" strokeLinecap="round"/>
    </g>

    <g className="question-mark">
      <path d="M85,0 Q92,0 92,5 Q92,10 87,12" fill="none" stroke="#FFCC33" strokeWidth="2.2" strokeLinecap="round" opacity="0.7"/>
      <circle cx="87" cy="17" r="1.5" fill="#FFCC33" opacity="0.7"/>
    </g>

    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const ProudSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="p-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="0.95"/>
        <stop offset="40%" stopColor="#FFCC33" stopOpacity="0.5"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="p-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <radialGradient id="p-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="p-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="5"/>
      </filter>
      <clipPath id="p-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="28" ry="20" fill="url(#p-glow)" filter="url(#p-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#p-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.4" clipPath="url(#p-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    <path d="M44,26 Q50,21 56,26" fill="none" stroke="#6B6568" strokeWidth="2" strokeLinecap="round"/>
    <path d="M64,26 Q70,21 76,26" fill="none" stroke="#6B6568" strokeWidth="2" strokeLinecap="round"/>

    {/* Anime blush — // lines, tucked inside face */}
    <line x1="40" y1="29" x2="41.5" y2="32" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="42" y1="29" x2="43.5" y2="32" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="44" y1="29" x2="45.5" y2="32" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="74.5" y1="29" x2="76" y2="32" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="76.5" y1="29" x2="78" y2="32" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>
    <line x1="78.5" y1="29" x2="80" y2="32" stroke="#FFCC33" strokeWidth="1" strokeLinecap="round" opacity="0.5"/>

    {/* Proud — content smile */}
    <path d="M52,36 Q60,42 68,36" fill="none" stroke="#6B6568" strokeWidth="1.5" strokeLinecap="round"/>

    <path d="M86,12 L88,6 L90,12 L84,9 L92,9 Z" fill="#FFCC33" opacity="0.5"/>
    <path d="M30,10 L32,5 L34,10 L28,8 L36,8 Z" fill="#FFCC33" opacity="0.4"/>

    {/* Confetti / party poppers — scattered dots and shapes */}
    <g className="confetti">
      <circle cx="20" cy="10" r="2" fill="#FFCC33"/>
      <rect x="95" y="5" width="3" height="3" fill="#F97316" transform="rotate(20 96 6)"/>
      <circle cx="12" cy="35" r="1.5" fill="#F97316"/>
      <rect x="100" y="30" width="2.5" height="2.5" fill="#FFCC33" transform="rotate(-15 101 31)"/>
      <circle cx="25" cy="55" r="1.5" fill="#006633"/>
      <rect x="15" y="22" width="2" height="4" fill="#bb3333" transform="rotate(30 16 24)"/>
      <circle cx="98" cy="52" r="2" fill="#006633"/>
      <rect x="88" y="20" width="2" height="4" fill="#bb3333" transform="rotate(-25 89 22)"/>
      <circle cx="8" cy="48" r="1" fill="#FFCC33"/>
      <rect x="105" y="44" width="2" height="3" fill="#F97316" transform="rotate(40 106 45)"/>
    </g>

    <path d="M50 12 Q47 2 44 -4" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="43.5" cy="-5" r="2.5" fill="#FFCC33"/>
    <path d="M70 12 Q73 2 76 -4" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="76.5" cy="-5" r="2.5" fill="#FFCC33"/>

    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const SurprisedSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="s-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="1"/>
        <stop offset="35%" stopColor="#FFCC33" stopOpacity="0.55"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="s-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <radialGradient id="s-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="s-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="5"/>
      </filter>
      <clipPath id="s-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="30" ry="22" fill="url(#s-glow)" filter="url(#s-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="38" cy="52" rx="17" ry="25" fill="#FFCC33" fillOpacity="0.15" stroke="#FFCC33" strokeOpacity="0.3" strokeWidth="0.8" transform="rotate(18 38 52)"/>
      <ellipse cx="82" cy="52" rx="17" ry="25" fill="#FFCC33" fillOpacity="0.15" stroke="#FFCC33" strokeOpacity="0.3" strokeWidth="0.8" transform="rotate(-18 82 52)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#s-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.4" clipPath="url(#s-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    {/* Eyes — wide circles for shock */}
    <circle cx="50" cy="25" r="8" fill="url(#s-eye-shine)"/>
    <circle cx="70" cy="25" r="8" fill="url(#s-eye-shine)"/>
    {/* Tiny pinpoint pupils */}
    <circle cx="50" cy="25.5" r="3" fill="#1A1A1A" className="eye-inner"/>
    <circle cx="70" cy="25.5" r="3" fill="#1A1A1A" className="eye-inner"/>
    <circle cx="48" cy="22.5" r="1.8" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="68" cy="22.5" r="1.8" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="52.5" cy="28" r="0.8" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>
    <circle cx="72.5" cy="28" r="0.8" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>

    <path d="M50 12 Q49 0 48 -5" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="48" cy="-6" r="2.5" fill="#FFCC33"/>
    <path d="M70 12 Q71 0 72 -5" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="72" cy="-6" r="2.5" fill="#FFCC33"/>

    <path d="M42,14 Q50,9 57,14" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <path d="M42,14 Q50,9 57,14" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M63,14 Q70,9 78,14" stroke="#3a3a3a" strokeWidth="4" strokeLinecap="round" fill="none"/>
    <path d="M63,14 Q70,9 78,14" stroke="#B8941A" strokeWidth="2" strokeLinecap="round" fill="none"/>

    <ellipse cx="60" cy="38" rx="4.5" ry="5" fill="#9A7080"/>

    {/* Exclamation mark — pops in */}
    <g className="exclamation-mark">
      <line x1="90" y1="4" x2="90" y2="16" stroke="#FFCC33" strokeWidth="2.5" strokeLinecap="round" opacity="0.7"/>
      <circle cx="90" cy="21" r="1.5" fill="#FFCC33" opacity="0.7"/>
    </g>

    {/* Speed lines — radiating outward */}
    <g className="speed-lines">
      <line x1="16" y1="18" x2="4" y2="14" stroke="#FFCC33" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      <line x1="14" y1="38" x2="2" y2="38" stroke="#FFCC33" strokeWidth="1.2" strokeLinecap="round" opacity="0.4"/>
      <line x1="18" y1="56" x2="6" y2="62" stroke="#FFCC33" strokeWidth="1.2" strokeLinecap="round" opacity="0.3"/>
      <line x1="104" y1="18" x2="116" y2="14" stroke="#FFCC33" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      <line x1="106" y1="38" x2="118" y2="38" stroke="#FFCC33" strokeWidth="1.2" strokeLinecap="round" opacity="0.4"/>
      <line x1="102" y1="56" x2="114" y2="62" stroke="#FFCC33" strokeWidth="1.2" strokeLinecap="round" opacity="0.3"/>
    </g>

    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const ErrorSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="er-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#bb3333" stopOpacity="0.6"/>
        <stop offset="40%" stopColor="#bb3333" stopOpacity="0.25"/>
        <stop offset="100%" stopColor="#bb3333" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="er-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#3A2020"/>
        <stop offset="78%" stopColor="#6A2222"/>
        <stop offset="90%" stopColor="#993030"/>
        <stop offset="100%" stopColor="#bb3333"/>
      </linearGradient>
      <radialGradient id="er-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="er-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
      </filter>
      <clipPath id="er-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    {/* Glow — red tinted */}
    <g className="glow">
      <ellipse cx="60" cy="90" rx="26" ry="18" fill="url(#er-glow)" filter="url(#er-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.08" stroke="#FFCC33" strokeOpacity="0.15" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.08" stroke="#FFCC33" strokeOpacity="0.15" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    {/* Body — red glow instead of yellow */}
    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#er-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#bb3333" opacity="0.3" clipPath="url(#er-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    {/* Spiral eyes — Archimedean spiral, spinning via CSS */}
    <path className="spiral-eye spiral-eye-l" d="M50,27 L50.1,27 L50.2,27.1 L50.2,27.2 L50.2,27.4 L50.2,27.6 L50,27.7 L49.8,27.8 L49.5,27.8 L49.3,27.7 L49,27.6 L48.8,27.3 L48.6,27 L48.5,26.6 L48.6,26.2 L48.8,25.8 L49.1,25.4 L49.5,25.1 L50,24.9 L50.6,24.9 L51.2,25 L51.7,25.3 L52.2,25.7 L52.6,26.3 L52.8,27 L52.8,27.8 L52.6,28.5 L52.2,29.2 L51.6,29.8 L50.9,30.3 L50,30.5 L49.1,30.5 L48.1,30.2 L47.3,29.7 L46.6,29 L46.1,28.1 L45.8,27 L45.8,25.9 L46.2,24.8 L46.8,23.8 L47.7,23 L48.8,22.4 L50,22.1 L51.3,22.2 L52.6,22.6 L53.7,23.3 L54.6,24.3 L55.3,25.6 L55.6,27 L55.5,28.5 L55.1,29.9 L54.2,31.2 L53,32.3 L51.6,33 L50,33.3 L48.3,33.2 L46.7,32.7 L45.3,31.7 L44.1,30.4 L43.4,28.8 L43,27" fill="none" stroke="#FFCC33" strokeWidth="1.5" strokeLinecap="round"/>
    <path className="spiral-eye spiral-eye-r" d="M70,27 L70.1,27 L70.2,27.1 L70.2,27.2 L70.2,27.4 L70.2,27.6 L70,27.7 L69.8,27.8 L69.5,27.8 L69.3,27.7 L69,27.6 L68.8,27.3 L68.6,27 L68.5,26.6 L68.6,26.2 L68.8,25.8 L69.1,25.4 L69.5,25.1 L70,24.9 L70.6,24.9 L71.2,25 L71.7,25.3 L72.2,25.7 L72.6,26.3 L72.8,27 L72.8,27.8 L72.6,28.5 L72.2,29.2 L71.6,29.8 L70.9,30.3 L70,30.5 L69.1,30.5 L68.1,30.2 L67.3,29.7 L66.6,29 L66.1,28.1 L65.8,27 L65.8,25.9 L66.2,24.8 L66.8,23.8 L67.7,23 L68.8,22.4 L70,22.1 L71.3,22.2 L72.6,22.6 L73.7,23.3 L74.6,24.3 L75.3,25.6 L75.6,27 L75.5,28.5 L75.1,29.9 L74.2,31.2 L73,32.3 L71.6,33 L70,33.3 L68.3,33.2 L66.7,32.7 L65.3,31.7 L64.1,30.4 L63.4,28.8 L63,27" fill="none" stroke="#FFCC33" strokeWidth="1.5" strokeLinecap="round"/>

    {/* Frown */}
    <path d="M53,38 Q60,34 67,38" fill="none" stroke="#6B6568" strokeWidth="1.5" strokeLinecap="round"/>

    {/* Antennae — drooping sadly (before vein so vein renders on top) */}
    <path d="M50 12 Q42 8 36 10" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="35" cy="9.5" r="2.5" fill="#FFCC33" opacity="0.5"/>
    <path d="M70 12 Q78 8 84 10" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="85" cy="9.5" r="2.5" fill="#FFCC33" opacity="0.5"/>

    {/* Anger/vein cross mark — clean X */}
    <g className="vein-mark">
      <path d="M78,2 L86,10 M86,2 L78,10" stroke="#bb3333" strokeWidth="3" strokeLinecap="round"/>
    </g>

    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,48 Q81,52 83,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const GreetingSVG = () => (
  <svg viewBox="0 -14 120 134">
    <defs>
      <radialGradient id="g-glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFCC33" stopOpacity="0.9"/>
        <stop offset="40%" stopColor="#FFCC33" stopOpacity="0.45"/>
        <stop offset="100%" stopColor="#FFCC33" stopOpacity="0"/>
      </radialGradient>
      <linearGradient id="g-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#505050"/>
        <stop offset="60%" stopColor="#3a3a3a"/>
        <stop offset="68%" stopColor="#4A3A1A"/>
        <stop offset="78%" stopColor="#9A7A20"/>
        <stop offset="90%" stopColor="#DDAA22"/>
        <stop offset="100%" stopColor="#FFCC33"/>
      </linearGradient>
      <radialGradient id="g-eye-shine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FFFFFF"/>
        <stop offset="100%" stopColor="#E0E0E0"/>
      </radialGradient>
      <filter id="g-softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="4"/>
      </filter>
      <clipPath id="g-bodyClip">
        <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z"/>
      </clipPath>
    </defs>

    <g className="glow">
      <ellipse cx="60" cy="90" rx="28" ry="20" fill="url(#g-glow)" filter="url(#g-softGlow)"/>
    </g>

    <g className="wings">
      <ellipse cx="42" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(25 42 56)"/>
      <ellipse cx="78" cy="56" rx="16" ry="24" fill="#FFCC33" fillOpacity="0.12" stroke="#FFCC33" strokeOpacity="0.25" strokeWidth="0.8" transform="rotate(-25 78 56)"/>
    </g>

    <path d="M43,40 Q39,52 41,66 Q43,80 50,88 Q56,92 60,92 Q64,92 70,88 Q77,80 79,66 Q81,52 77,40 Q72,32 60,32 Q48,32 43,40 Z" fill="url(#g-body)"/>
    <ellipse cx="60" cy="86" rx="18" ry="10" fill="#FFCC33" opacity="0.35" clipPath="url(#g-bodyClip)"/>
    <ellipse cx="60" cy="44" rx="15" ry="9" fill="#505050" opacity="0.3"/>

    <ellipse cx="60" cy="28" rx="22" ry="20" fill="#3a3a3a"/>

    {/* Eyes — happy, slightly bigger */}
    <path d="M43,26 Q43,19 50,18 Q57,19 57,26 Q57,32 50,32 Q43,32 43,26 Z" fill="url(#g-eye-shine)"/>
    <path d="M63,26 Q63,19 70,18 Q77,19 77,26 Q77,32 70,32 Q63,32 63,26 Z" fill="url(#g-eye-shine)"/>
    <ellipse cx="50" cy="27" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
    <ellipse cx="70" cy="27" rx="4" ry="4.5" fill="#1A1A1A" className="eye-inner"/>
    <circle cx="48" cy="23.5" r="2" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="68" cy="23.5" r="2" fill="#FFFFFF" className="eye-inner"/>
    <circle cx="52.5" cy="29" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>
    <circle cx="72.5" cy="29" r="1" fill="#FFFFFF" opacity="0.7" className="eye-inner"/>

    {/* Happy smile */}
    <path d="M52,36 Q60,42 68,36" fill="none" stroke="#6B6568" strokeWidth="1.5" strokeLinecap="round"/>

    {/* Waving leg — front-right leg raised up */}
    <g className="wave-hand">
      <path d="M78,48 Q86,42 90,36" fill="none" stroke="#464646" strokeWidth="1.8" strokeLinecap="round"/>
      {/* Little hand/mitt at the end */}
      <circle cx="91" cy="35" r="2.5" fill="#464646"/>
    </g>

    {/* Antennae — perky */}
    <path d="M50 12 Q47 3 43 -2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="42.5" cy="-3" r="2.5" fill="#FFCC33"/>
    <path d="M70 12 Q73 3 77 -2" fill="none" stroke="#464646" strokeWidth="2" strokeLinecap="round"/>
    <circle cx="77.5" cy="-3" r="2.5" fill="#FFCC33"/>

    {/* Remaining legs (skip front-right, it's the wave) */}
    <path d="M45,48 Q39,52 37,56" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M43,57 Q37,62 35,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M77,57 Q83,62 85,67" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M45,66 Q40,72 38,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
    <path d="M75,66 Q80,72 82,76" fill="none" stroke="#464646" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const SVG_MAP = {
  neutral: NeutralSVG,
  steady: SteadySVG,
  laughing: LaughingSVG,
  thinking: ThinkingSVG,
  excited: ExcitedSVG,
  concerned: ConcernedSVG,
  confused: ConfusedSVG,
  proud: ProudSVG,
  surprised: SurprisedSVG,
  error: ErrorSVG,
  greeting: GreetingSVG,
};

const SKIP_BLINK = ['proud', 'surprised', 'error', 'steady', 'laughing'];

const FlerpieAvatar = ({ emotion = 'neutral', size = 64 }) => {
  const [isBlinking, setIsBlinking] = useState(false);
  const delayRef = useRef(null);
  const blinkRef = useRef(null);

  useEffect(() => {
    if (SKIP_BLINK.includes(emotion)) return;

    const scheduleBlink = () => {
      const delay = 3000 + Math.random() * 2000;
      delayRef.current = setTimeout(() => {
        setIsBlinking(true);
        blinkRef.current = setTimeout(() => {
          setIsBlinking(false);
          scheduleBlink();
        }, 150);
      }, delay);
    };

    scheduleBlink();
    return () => {
      clearTimeout(delayRef.current);
      clearTimeout(blinkRef.current);
      setIsBlinking(false);
    };
  }, [emotion]);

  const SVGComponent = SVG_MAP[emotion] || SVG_MAP.neutral;

  return (
    <div
      className={`flerpie-avatar flerpie-avatar--${emotion}${isBlinking ? ' flerpie-blinking' : ''}`}
      style={{ width: size, height: size, colorScheme: 'only light' }}
      data-darkreader-inline-color=""
    >
      <SVGComponent />
    </div>
  );
};

export default FlerpieAvatar;
